import { api } from '../index';

const TEACHER_BASE_URL = 'api/teachers/me';
const ZOOM_BASE_URL = 'api/zoom';
const GOOGLE_CALENDAR_CONNECTIONS_BASE_URL = 'api/googlecalendar';
const GOOGLE_MAIL_CONNECTIONS_BASE_URL = 'api/googlemail';
const GOOGLE_MEET_CONNECTIONS_BASE_URL = 'api/googlemeet';
const API_BASE_URL = 'api';

async function getCurrencies(type: string): Promise<CurrencyResponse[]> {
  const result = await api.get<CurrencyResponse[]>(
    `${TEACHER_BASE_URL}/currencies`,
    {
      params: {
        type: type,
      },
    }
  );
  return result.data;
}

async function getDomain(): Promise<DomainResponse> {
  const result = await api.get<DomainResponse>('v2/teachers/domain');
  return result.data;
}
async function setDomain(data: DomainRequest): Promise<DomainResponse> {
  const result = await api.post<DomainResponse>('v2/teachers/domain', data);
  return result.data;
}
async function deleteDomain(): Promise<void> {
  const result = await api.delete<void>('v2/teachers/domain');
  return result.data;
}
async function getPagesDomain(): Promise<DomainResponse> {
  const result = await api.get<DomainResponse>('v2/teachers/pages-domain');
  return result.data;
}
async function setPagesDomain(data: DomainRequest): Promise<DomainResponse> {
  const result = await api.post<DomainResponse>(
    'v2/teachers/pages-domain',
    data
  );
  return result.data;
}
async function deletePagesDomain(): Promise<void> {
  const result = await api.delete<void>('v2/teachers/pages-domain');
  return result.data;
}
async function toggleCodeEmbedEnabled(
  codeEmbedEnabled
): Promise<CodeEmbedResponse> {
  const result = await api.put<CodeEmbedResponse>(
    `${TEACHER_BASE_URL}/code_embed`,
    {
      code_embed_enabled: codeEmbedEnabled,
    }
  );
  return result.data;
}
async function updateCodeEmbedScripts(
  scriptsString
): Promise<CodeEmbedResponse> {
  const result = await api.put<CodeEmbedResponse>(
    `${TEACHER_BASE_URL}/code_embed`,
    {
      global_scripts: scriptsString,
    }
  );
  return result.data;
}
async function getCodeEmbed(): Promise<CodeEmbedResponse> {
  const result = await api.get<CodeEmbedResponse>(
    `${TEACHER_BASE_URL}/code_embed`
  );
  return result.data;
}

async function getCheckoutSettings(): Promise<AccountCheckoutSettingsResponse> {
  const result = await api.get<AccountCheckoutSettingsResponse>(
    `${TEACHER_BASE_URL}/checkout_settings`
  );
  return result.data;
}

async function updateCheckoutSettings(
  data: AccountCheckoutSettingsResponse
): Promise<AccountCheckoutSettingsResponse> {
  const result = await api.patch<AccountCheckoutSettingsResponse>(
    `${TEACHER_BASE_URL}/checkout_settings`,
    data
  );
  return result.data;
}

async function getAccountInfo(): Promise<AccountInfoResponse> {
  const result = await api.get<AccountInfoResponse>(
    `${TEACHER_BASE_URL}/account_info`
  );
  return result.data;
}

async function getAccountSubscriptionInfo(data): Promise<AccountInfoResponse> {
  const result = await api.post<AccountInfoResponse>(
    `${TEACHER_BASE_URL}/account_info`,
    data
  );
  return result.data;
}
async function getSetupIntent(): Promise<any> {
  const result = await api.post<any>(`${TEACHER_BASE_URL}/setupintent`);
  return result.data;
}

async function getPaymentInfo(): Promise<PaymentInfoResponse> {
  const result = await api.get<PaymentInfoResponse>(
    `${TEACHER_BASE_URL}/payment_info`
  );
  return result.data;
}

async function cancelSubscription(payload): Promise<any> {
  const result = await api.post<any>(
    `${TEACHER_BASE_URL}/cancel_subscription`,
    payload
  );
  return result.data;
}

async function updatePaymentInfo(
  data: PaymentInfoRequest
): Promise<PaymentInfoResponse> {
  const result = await api.put<PaymentInfoResponse>(
    `${TEACHER_BASE_URL}/payment_info`,
    data
  );
  return result.data;
}

async function updateCurrency(
  currencyCode: string
): Promise<PaymentInfoResponse> {
  const data = {
    currency: currencyCode,
  };
  const result = await api.patch<PaymentInfoResponse>(
    `${TEACHER_BASE_URL}/payment_info`,
    data
  );
  return result.data;
}

async function connectStripe(code: string): Promise<PaymentInfoResponse> {
  const data = {
    auth_code: code,
  };
  const result = await api.post<PaymentInfoResponse>(
    `${TEACHER_BASE_URL}/connect_stripe`,
    data
  );
  return result.data;
}

async function disconnectStripe(): Promise<PaymentInfoResponse> {
  const result = await api.post<PaymentInfoResponse>(
    `${TEACHER_BASE_URL}/disconnect_stripe`
  );
  return result.data;
}

async function getEmailProvidersInfo(): Promise<EmailProviderInfoResponse> {
  const result = await api.get<EmailProviderInfoResponse>(
    `${TEACHER_BASE_URL}/email_providers_info`
  );
  return result.data;
}

async function updateEmailProvidersInfo(
  data: EmailInfoRequest
): Promise<EmailProviderInfoResponse> {
  const result = await api.put<EmailProviderInfoResponse>(
    `${TEACHER_BASE_URL}/email_providers_info`,
    data
  );
  return result.data;
}

async function getFlodeskSegments(): Promise<FlodeskSegmentResponse[]> {
  const result = await api.get<FlodeskSegmentResponse[]>(
    `${TEACHER_BASE_URL}/flodesk_segments`
  );
  return result.data;
}

async function getMailChimpLists(): Promise<MailChimpListsResponse> {
  const result = await api.get<MailChimpListsResponse>(
    `${TEACHER_BASE_URL}/mailchimp_lists`
  );
  return result.data;
}

async function updateMailChimpLists(): Promise<MailChimpListsResponse> {
  const result = await api.put<MailChimpListsResponse>(
    `${TEACHER_BASE_URL}/mailchimp_lists`
  );
  return result.data;
}

async function getConvertkitTags(): Promise<ConvertKitResponse> {
  const result = await api.get<ConvertKitResponse>(
    `${TEACHER_BASE_URL}/convertkit_tags`
  );
  return result.data;
}

async function updateConvertkitTags(): Promise<ConvertKitResponse> {
  const result = await api.put<ConvertKitResponse>(
    `${TEACHER_BASE_URL}/convertkit_tags`
  );
  return result.data;
}

async function getFBPixel(): Promise<FBPixelResponse> {
  const result = await api.get<FBPixelResponse>(`${TEACHER_BASE_URL}/fb_pixel`);
  return result.data;
}

async function updateFBPixel(data: FBPixelRequest): Promise<FBPixelResponse> {
  const result = await api.put<FBPixelResponse>(
    `${TEACHER_BASE_URL}/fb_pixel`,
    data
  );
  return result.data;
}

async function getGoogleAnalyticsCode(): Promise<GoogleAnalyticsCodeResponse> {
  const result = await api.get<GoogleAnalyticsCodeResponse>(
    `${TEACHER_BASE_URL}/google_analytics_code`
  );
  return result.data;
}

async function updateGoogleAnalyticsCode(
  data: GoogleAnalyticsCodeResponse
): Promise<GoogleAnalyticsCodeResponse> {
  const result = await api.put<GoogleAnalyticsCodeResponse>(
    `${TEACHER_BASE_URL}/google_analytics_code`,
    data
  );
  return result.data;
}

async function getGoogleCalendarConnections(): Promise<
  GoogleCalendarConnectionResponse[]
> {
  const result = await api.get<GoogleCalendarConnectionResponse[]>(
    `${GOOGLE_CALENDAR_CONNECTIONS_BASE_URL}`
  );
  return result.data;
}

async function addGoogleCalendarConnection(
  code: string,
  scope: string
): Promise<GoogleCalendarConnectionResponse> {
  const result = await api.post<GoogleCalendarConnectionResponse>(
    `${GOOGLE_CALENDAR_CONNECTIONS_BASE_URL}/connect`,
    {
      oauth_code: code,
      scope: scope,
    }
  );
  return result.data;
}

async function updateGoogleCalendarConnection(
  data: GoogleCalendarRequest
): Promise<GoogleCalendarConnectionResponse> {
  const result = await api.put<GoogleCalendarConnectionResponse>(
    `${GOOGLE_CALENDAR_CONNECTIONS_BASE_URL}/${data.id}`,
    data
  );
  return result.data;
}

async function setGoogleCalendarDefaultConnection(
  connectionId: number
): Promise<GoogleCalendarConnectionResponse> {
  const result = await api.post<GoogleCalendarConnectionResponse>(
    `${GOOGLE_CALENDAR_CONNECTIONS_BASE_URL}/${connectionId}/default`
  );
  return result.data;
}

async function setGoogleCalendarConnectionName(
  connectionId: number,
  name: string
): Promise<GoogleCalendarConnectionResponse> {
  const result = await api.put<GoogleCalendarConnectionResponse>(
    `${GOOGLE_CALENDAR_CONNECTIONS_BASE_URL}/${connectionId}`,
    { name }
  );
  return result.data;
}

async function removeGoogleCalendarConnection(
  connectionId: number
): Promise<void> {
  const result = await api.delete<void>(
    `${GOOGLE_CALENDAR_CONNECTIONS_BASE_URL}/${connectionId}`
  );
  return result.data;
}

async function getGoogleMailConnections(): Promise<
  GoogleMailConnectionResponse[]
> {
  const result = await api.get<GoogleMailConnectionResponse[]>(
    `${GOOGLE_MAIL_CONNECTIONS_BASE_URL}`
  );
  return result.data;
}

async function addGoogleMailConnection(
  code: string,
  scope: string
): Promise<GoogleMailConnectionResponse> {
  const result = await api.post<GoogleMailConnectionResponse>(
    `${GOOGLE_MAIL_CONNECTIONS_BASE_URL}/connect`,
    {
      oauth_code: code,
      scope: scope,
    }
  );
  return result.data;
}

async function updateGoogleMailConnection(
  data: GoogleCalendarRequest
): Promise<GoogleMailConnectionResponse> {
  const result = await api.put<GoogleMailConnectionResponse>(
    `${GOOGLE_MAIL_CONNECTIONS_BASE_URL}/${data.id}`,
    data
  );
  return result.data;
}

async function setGoogleMailDefaultConnection(
  connectionId: number
): Promise<GoogleMailConnectionResponse> {
  const result = await api.post<GoogleMailConnectionResponse>(
    `${GOOGLE_MAIL_CONNECTIONS_BASE_URL}/${connectionId}/default`
  );
  return result.data;
}

async function setGoogleMailConnectionName(
  connectionId: number,
  name: string
): Promise<GoogleMailConnectionResponse> {
  const result = await api.put<GoogleMailConnectionResponse>(
    `${GOOGLE_MAIL_CONNECTIONS_BASE_URL}/${connectionId}`,
    { name }
  );
  return result.data;
}

async function removeGoogleMailConnection(connectionId: number): Promise<void> {
  const result = await api.delete<void>(
    `${GOOGLE_MAIL_CONNECTIONS_BASE_URL}/${connectionId}`
  );
  return result.data;
}

async function getGoogleMeetConnections(): Promise<
  GoogleMeetConnectionResponse[]
> {
  const result = await api.get<GoogleMeetConnectionResponse[]>(
    `${GOOGLE_MEET_CONNECTIONS_BASE_URL}`
  );
  return result.data;
}

async function addGoogleMeetConnection(
  code: string,
  scope: string
): Promise<GoogleMeetConnectionResponse> {
  const result = await api.post<GoogleMeetConnectionResponse>(
    `${GOOGLE_MEET_CONNECTIONS_BASE_URL}/connect`,
    {
      oauth_code: code,
      scope: scope,
    }
  );
  return result.data;
}

async function updateGoogleMeetConnection(
  data: GoogleMeetRequest
): Promise<GoogleMeetConnectionResponse> {
  const result = await api.put<GoogleMeetConnectionResponse>(
    `${GOOGLE_MEET_CONNECTIONS_BASE_URL}/${data.id}`,
    data
  );
  return result.data;
}

async function setGoogleMeetDefaultConnection(
  connectionId: number
): Promise<GoogleMeetConnectionResponse> {
  const result = await api.post<GoogleMeetConnectionResponse>(
    `${GOOGLE_MEET_CONNECTIONS_BASE_URL}/${connectionId}/default`
  );
  return result.data;
}

async function setGoogleMeetConnectionName(
  connectionId: number,
  name: string
): Promise<GoogleMeetConnectionResponse> {
  const result = await api.put<GoogleMeetConnectionResponse>(
    `${GOOGLE_MEET_CONNECTIONS_BASE_URL}/${connectionId}`,
    { name }
  );
  return result.data;
}

async function removeGoogleMeetConnection(connectionId: number): Promise<void> {
  const result = await api.delete<void>(
    `${GOOGLE_MEET_CONNECTIONS_BASE_URL}/${connectionId}`
  );
  return result.data;
}

async function getZoomConnections(): Promise<ZoomInfoResponse[]> {
  const result = await api.get<ZoomInfoResponse[]>(`${ZOOM_BASE_URL}`);
  return result.data;
}

async function addZoomConnection(
  zoomOauthCode: string
): Promise<ZoomInfoResponse> {
  const result = await api.post<ZoomInfoResponse>(`${ZOOM_BASE_URL}/connect`, {
    zoom_oauth_code: zoomOauthCode,
  });
  return result.data;
}

async function getZoomSettings(): Promise<ZoomSettingsResponse> {
  const result = await api.get<ZoomSettingsResponse>(`${ZOOM_BASE_URL}/config`);
  return result.data;
}

async function updateZoomSettings(
  data: ZoomSettingsRequest
): Promise<ZoomSettingsResponse> {
  const result = await api.put<ZoomSettingsResponse>(
    `${ZOOM_BASE_URL}/config`,
    data
  );
  return result.data;
}

async function updateZoomConnection(
  data: ZoomRequest
): Promise<ZoomInfoResponse> {
  const result = await api.put<ZoomInfoResponse>(
    `${ZOOM_BASE_URL}/${data.id}`,
    data
  );
  return result.data;
}

async function setZoomDefaultConnection(
  zoomConnectionId: number
): Promise<ZoomInfoResponse> {
  const result = await api.post<ZoomInfoResponse>(
    `${ZOOM_BASE_URL}/${zoomConnectionId}/default`
  );
  return result.data;
}

async function refreshZoomConnection(
  zoomConnectionId: number
): Promise<ZoomInfoResponse> {
  const result = await api.post<ZoomInfoResponse>(
    `${ZOOM_BASE_URL}/${zoomConnectionId}/refresh`
  );
  return result.data;
}

async function setZoomConnectionName(
  zoomConnectionId: number,
  name: string
): Promise<ZoomInfoResponse> {
  const result = await api.put<ZoomInfoResponse>(
    `${ZOOM_BASE_URL}/${zoomConnectionId}`,
    { name }
  );
  return result.data;
}

async function removeZoomConnection(zoomConnectionId: number): Promise<void> {
  const result = await api.delete<void>(`${ZOOM_BASE_URL}/${zoomConnectionId}`);
  return result.data;
}

async function getWaiver(): Promise<WaiverResponse> {
  const result = await api.get<WaiverResponse>('api/waivers/latest');
  return result.data;
}

async function getWaivers(): Promise<WaiverResponse[]> {
  const result = await api.get<WaiverResponse[]>('api/waivers');
  return result.data;
}

async function getWaiverSigners(waiverId): Promise<SignedWaiverResponse[]> {
  const result = await api.get<SignedWaiverResponse[]>(
    `api/waivers/${waiverId}/signers`
  );
  return result.data;
}

async function updateWaiver(data: WaiverRequest): Promise<WaiverResponse> {
  const result = await api.post<WaiverResponse>('api/waivers', data);
  return result.data;
}

async function getCalendly(): Promise<string> {
  const result = await api.get<string>(`${TEACHER_BASE_URL}/calendly_api_key`);
  return result.data;
}

async function updateCalendly(data: CalendlyRequest): Promise<string> {
  const result = await api.put<string>(
    `${TEACHER_BASE_URL}/calendly_api_key`,
    data
  );
  return result.data;
}

async function getCalendlyV2(): Promise<CalendlyV2Request> {
  const result = await api.get<CalendlyV2Request>(
    `${TEACHER_BASE_URL}/calendly_v2`
  );
  return result.data;
}

async function updateCalendlyV2(data: CalendlyV2Request): Promise<string> {
  const result = await api.put<string>(`${TEACHER_BASE_URL}/calendly_v2`, data);
  return result.data;
}

async function getFlodesk(): Promise<FlodeskResponse> {
  const result = await api.get<FlodeskResponse>(`${TEACHER_BASE_URL}/flodesk`);
  return result.data;
}

async function updateFlodesk(data: FlodeskRequest): Promise<string> {
  const result = await api.put<string>(`${TEACHER_BASE_URL}/flodesk`, data);
  return result.data;
}

async function getTwilio(): Promise<TwilioRequest> {
  const result = await api.get<TwilioRequest>(`${TEACHER_BASE_URL}/twilio`);
  return result.data;
}

async function updateTwilio(data: TwilioRequest): Promise<string> {
  const result = await api.put<string>(`${TEACHER_BASE_URL}/twilio`, data);
  return result.data;
}

async function sendSMS(sms: SMSRequest): Promise<string> {
  const result = await api.post<string>(`${TEACHER_BASE_URL}/send_sms`, sms);
  return result.data;
}

async function getSmtpInfo(): Promise<SmtpResponse> {
  const result = await api.get<SmtpResponse>(`${TEACHER_BASE_URL}/smtp`);
  return result.data;
}
async function updateSmtpInfo(data: SmtpResponse): Promise<SmtpResponse> {
  const result = await api.put<SmtpResponse>(`${TEACHER_BASE_URL}/smtp`, data);
  return result.data;
}

async function getAcuityInfo(): Promise<AcuityResponse> {
  const result = await api.get<AcuityResponse>(
    `${TEACHER_BASE_URL}/acuity_info`
  );
  return result.data;
}
async function updateAcuityInfo(data: AcuityRequest): Promise<AcuityResponse> {
  const result = await api.put<AcuityResponse>(
    `${TEACHER_BASE_URL}/acuity_info`,
    data
  );
  return result.data;
}

async function getDeadlineFunnelKey(): Promise<string> {
  const result = await api.get<string>(
    `${TEACHER_BASE_URL}/deadline_funnel_key`
  );
  return result.data;
}

async function updateDeadlineFunnelKey(
  data: DeadlineFunnelRequest
): Promise<string> {
  const result = await api.put<string>(
    `${TEACHER_BASE_URL}/deadline_funnel_key`,
    data
  );
  return result.data;
}

async function getRewardfulKey(): Promise<string> {
  const result = await api.get<string>(`${TEACHER_BASE_URL}/rewardful_api_key`);
  return result.data;
}

async function updateRewardfulKey(data: RewardfulRequest): Promise<string> {
  const result = await api.put<string>(
    `${TEACHER_BASE_URL}/rewardful_api_key`,
    data
  );
  return result.data;
}

async function getIntegrationsStatus(): Promise<IntegrationsStatusResponse> {
  const result = await api.get<IntegrationsStatusResponse>(
    `${TEACHER_BASE_URL}/integrations_status`
  );
  return result.data;
}

async function getInvoiceHistory(): Promise<InvoiceHistoryResponse> {
  const url = `${TEACHER_BASE_URL}/invoice_history`;
  const result = await api.get<InvoiceHistoryResponse>(url);
  return result.data;
}

async function createStudent(data): Promise<InvoiceHistoryResponse> {
  const url = `${TEACHER_BASE_URL}/create_student`;
  const result = await api.post<InvoiceHistoryResponse>(url, data);
  return result.data;
}
async function getTipJarInfo(): Promise<TipJarIntegrationResponse> {
  const url = `${TEACHER_BASE_URL}/tip_jar`;
  const result = await api.get<TipJarIntegrationResponse>(url);
  return result.data;
}
async function updateTipJarInfo(
  data: TipJarIntegrationRequest
): Promise<TipJarIntegrationResponse> {
  const url = `${TEACHER_BASE_URL}/tip_jar`;
  const result = await api.put<TipJarIntegrationResponse>(url, data);
  return result.data;
}

async function getBioTemplates(): Promise<BioTemplateResponse> {
  const result = await api.get<BioTemplateResponse>(
    `${API_BASE_URL}/bio-templates`
  );
  return result.data;
}

async function getMarvelousBioInfo(): Promise<BioResponse> {
  const url = `${API_BASE_URL}/bio/me`;
  const result = await api.get<BioResponse>(url);
  return result.data;
}
async function updateMarvelousBioInfo(data: BioResponse): Promise<BioResponse> {
  const url = `${API_BASE_URL}/bio/me`;
  const result = await api.put<BioResponse>(url, data);
  return result.data;
}
async function addBioLink(data: BioLink): Promise<BioLink> {
  const url = `${API_BASE_URL}/bio-links`;
  const result = await api.post<BioLink>(url, data);
  return result.data;
}
async function updateBioLink(data: any): Promise<BioLink> {
  const url = `${API_BASE_URL}/bio-links/${data.id}`;
  const result = await api.put<BioLink>(url, data);
  return result.data;
}
async function deleteBioLink(id: any): Promise<void> {
  const url = `${API_BASE_URL}/bio-links/${id}`;
  const result = await api.delete<any>(url);
  return result.data;
}

export default {
  getCurrencies,
  getDomain,
  setDomain,
  deleteDomain,
  getPagesDomain,
  setPagesDomain,
  deletePagesDomain,
  getAccountInfo,
  getAccountSubscriptionInfo,
  getSetupIntent,
  getPaymentInfo,
  updatePaymentInfo,
  updateCurrency,
  connectStripe,
  disconnectStripe,
  getEmailProvidersInfo,
  updateEmailProvidersInfo,
  getFlodeskSegments,
  getMailChimpLists,
  updateMailChimpLists,
  getConvertkitTags,
  updateConvertkitTags,
  getFBPixel,
  updateFBPixel,
  getGoogleAnalyticsCode,
  updateGoogleAnalyticsCode,
  getZoomSettings,
  updateZoomSettings,
  getZoomConnections,
  addZoomConnection,
  updateZoomConnection,
  setZoomDefaultConnection,
  refreshZoomConnection,
  setZoomConnectionName,
  removeZoomConnection,
  getWaiver,
  getWaivers,
  getWaiverSigners,
  updateWaiver,
  getCalendly,
  updateCalendly,
  getCalendlyV2,
  updateCalendlyV2,
  getTwilio,
  updateTwilio,
  sendSMS,
  getDeadlineFunnelKey,
  updateDeadlineFunnelKey,
  getInvoiceHistory,
  cancelSubscription,
  getAcuityInfo,
  updateAcuityInfo,
  createStudent,
  getTipJarInfo,
  updateTipJarInfo,
  getBioTemplates,
  getMarvelousBioInfo,
  updateMarvelousBioInfo,
  addBioLink,
  updateBioLink,
  deleteBioLink,
  toggleCodeEmbedEnabled,
  updateCodeEmbedScripts,
  getCodeEmbed,
  getSmtpInfo,
  updateSmtpInfo,
  getCheckoutSettings,
  updateCheckoutSettings,
  getGoogleCalendarConnections,
  addGoogleCalendarConnection,
  updateGoogleCalendarConnection,
  setGoogleCalendarDefaultConnection,
  setGoogleCalendarConnectionName,
  removeGoogleCalendarConnection,
  getGoogleMailConnections,
  addGoogleMailConnection,
  updateGoogleMailConnection,
  setGoogleMailDefaultConnection,
  setGoogleMailConnectionName,
  removeGoogleMailConnection,
  getGoogleMeetConnections,
  addGoogleMeetConnection,
  updateGoogleMeetConnection,
  setGoogleMeetDefaultConnection,
  setGoogleMeetConnectionName,
  removeGoogleMeetConnection,
  getFlodesk,
  updateFlodesk,
  getRewardfulKey,
  updateRewardfulKey,
  getIntegrationsStatus,
};
